import { activateI18n } from '../i18n';
import { messages as enMessages } from '../locales/en/messages';
import { messages as fiMessages } from '../locales/fi/messages';
import { messages as nbMessages } from '../locales/nb/messages';

activateI18n(enMessages, nbMessages, fiMessages);

export { AdImage } from './ad/AdImage';
export { BapSearchAd } from './search/bap/BapSearchAd';
export { BoatSearchAd } from './search/boat/BoatSearchAd';
export { JobSearchAd } from './search/job/JobSearchAd';
export { MotorSearchAd } from './search/motor/MotorSearchAd';
export { AdOfTheWeekSearchAd } from './search/realestate/AdOfTheWeekSearchAd';
export { RealestateSearchAd } from './search/realestate/RealestateSearchAd';
